import apiService from '@/services/api.service'
import store from '@/store'

export default {

    async getLogins() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getLoginsForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty logins!')
                }
            }).catch((error) => {
                
                reject(error)
            })
        })
    },

    async getTours() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getToursForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty tours!')
                }
            }).catch((error) => {
                
                reject(error)
            })
        })
    },

    async getHotels() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getHotelsForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty hotels!')
                }
            }).catch((error) => {
                
                reject(error)
            })
        })
    },

    async getChats() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getChatsForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty chats!')
                }
            }).catch((error) => {
                
                reject(error)
            })
        })
    },

    async getFilters() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getFiltersForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty filters!')
                }
            }).catch((error) => {
                
                reject(error)
            })
        })
    },

    async getClaims(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getClaims',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty claims!')
                }
            }).catch((error) => {
                
                reject(error)
            })
        })
    },

    async getReport(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getReport',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response);
            }).catch((error) => {
                
                reject(error)
            })
        })
    },

    async setRead(params) {
        const lang = store.state.locale;
        const chatId = params.chatId;

        console.log('Sending request with params:', {
            url: 'claims/setRead',
            method: 'get',
            params: { chatId }
        });

        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/setRead',
                method: 'get',
                params: { chatId },
                locale: lang
            })
                .then((response) => {
                    console.log('Received response:', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    console.error('Error in setRead:', error);
                    reject(error);
                });
        });
    }
}
